// const axios = require("axios");
import axios from "axios";
import { fabric } from "fabric";
const fontMachine = async (fontFamily) => {
  const data = await axios
    .get(
      "https://webfonts.googleapis.com/v1/webfonts?sort=STYLE&key=AIzaSyAAiOkCBmUBGJPQvjK1RmQVnhNMdgro2nU"
    )
    .then((res) => {
      return res.data.items;
    })
    .catch((err) => {
      console.log(err);
    });
  let dicturl = {};
  let Variant = ["regular"];

  for (let i = 0; i <= data.length - 1; i++) {
    for (let j = 0; j <= fontFamily.length - 1; j++) {
      if (data[i].family == fontFamily[j]) {
        dicturl[data[i].family] = {};
        for (let k = 0; k <= Variant.length - 1; k++) {
          dicturl[data[i].family][Variant[k]] = data[i].files[Variant[k]];

          if (data[i].files[Variant[k]]) {
            let font = new FontFace(
              fontFamily[j],
              `url(${data[i].files[Variant[k]].replace("http://", "https://")})`
            );
            await font.load().then((loadedFont) => {
              document.fonts.add(loadedFont);
            });
            console.log(fontFamily[j]);
            console.log(fabric.fonts, "error1");
            await fabric.fonts
              .push({
                family: fontFamily[j],
                source: loadedFont.src,
              })
              .catch((error) => {
                console.error("Error Loading font:", error);
              });
          }
        }
      }
    }
  }

  console.log(dicturl);
  return data;
};
export { fontMachine };
